// This gets replaced at build time by Next.js
export const VERSION = process.env.APP_VERSION || "1";
